// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Layout.css */

.app-layout {
	display: flex;
  }
  
  /* Main content area that takes remaining space */
  .main-content {
	margin-left: 250px; /* Same as sidebar width */
	padding: 25px;
	width: calc(100% - 250px); /* Full width minus sidebar */
	min-height: 100vh;
	background-color: #f8f9fa; /* Light background for content area */
	position: relative; /* Needed for absolute positioning of children like button/panel */
	box-sizing: border-box;
  }
  
  .page-content {
	  /* Add specific styles for the area where route components render if needed */
	  background-color: #ffffff; /* White background for page content */
	  padding: 20px;
	  border-radius: 8px;
	  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }
  
  
  .settings-toggle-button {
	  position: absolute;
	  top: 20px;
	  right: 25px;
	  z-index: 1001; /* Above settings panel overlay */
	  background-color: #6c757d;
	  color: white;
	  border: none;
	  border-radius: 50%;
	  width: 50px;
	  height: 50px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  cursor: pointer;
	  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	  transition: background-color 0.2s ease;
  }
  
  .settings-toggle-button:hover {
	  background-color: #5a6268;
  }
  
  /* Style for the settings panel when it's overlaid */
  /* We apply this class directly in Layout.js */
  .settings-panel-overlay {
	  position: absolute;
	  top: 80px; /* Below the toggle button */
	  right: 25px;
	  z-index: 1000; /* Below toggle, above content */
	  width: 320px;
	  max-width: 90%; /* Ensure it fits on smaller screens */
	  background-color: white;
	  border-radius: 8px;
	  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
	  border: 1px solid #dee2e6;
  }
  
  /* Adjust SettingsPanel internal styles slightly if needed */
  .settings-panel-overlay h4 {
	  margin-top: 0;
	  padding-bottom: 10px;
	  border-bottom: 1px solid #eee;
  }
  
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
	.main-menu {
	  /* Example: Make sidebar smaller or collapsible on smaller screens */
	  width: 60px;
	}
  
	.main-menu .menu-title,
	.main-menu .menu-text {
	  display: none; /* Hide text, show only icons */
	}
  
	 .main-menu .menu-link {
	   justify-content: center;
	   padding: 15px 0;
	 }
	 .main-menu .menu-icon {
	   margin-right: 0;
	 }
	 .main-menu .menu-header {
		padding: 15px 0;
		justify-content: center;
	 }
	  .main-menu .menu-logo-icon {
		  margin-right: 0;
	  }
  
	.main-content {
	  margin-left: 60px; /* Adjust margin to match collapsed sidebar */
	  width: calc(100% - 60px);
	  padding: 15px;
	}
  
	.settings-toggle-button {
		top: 15px;
		right: 15px;
		width: 45px;
		height: 45px;
	}
	.settings-panel-overlay {
		top: 70px;
		right: 15px;
	}
  
  }`, "",{"version":3,"sources":["webpack://./src/components/Layout.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;CACC,aAAa;EACZ;;EAEA,iDAAiD;EACjD;CACD,kBAAkB,EAAE,0BAA0B;CAC9C,aAAa;CACb,yBAAyB,EAAE,6BAA6B;CACxD,iBAAiB;CACjB,yBAAyB,EAAE,sCAAsC;CACjE,kBAAkB,EAAE,kEAAkE;CACtF,sBAAsB;EACrB;;EAEA;GACC,6EAA6E;GAC7E,yBAAyB,EAAE,sCAAsC;GACjE,aAAa;GACb,kBAAkB;GAClB,sCAAsC;EACvC;;;EAGA;GACC,kBAAkB;GAClB,SAAS;GACT,WAAW;GACX,aAAa,EAAE,iCAAiC;GAChD,yBAAyB;GACzB,YAAY;GACZ,YAAY;GACZ,kBAAkB;GAClB,WAAW;GACX,YAAY;GACZ,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,eAAe;GACf,wCAAwC;GACxC,sCAAsC;EACvC;;EAEA;GACC,yBAAyB;EAC1B;;EAEA,oDAAoD;EACpD,8CAA8C;EAC9C;GACC,kBAAkB;GAClB,SAAS,EAAE,4BAA4B;GACvC,WAAW;GACX,aAAa,EAAE,gCAAgC;GAC/C,YAAY;GACZ,cAAc,EAAE,sCAAsC;GACtD,uBAAuB;GACvB,kBAAkB;GAClB,yCAAyC;GACzC,yBAAyB;EAC1B;;EAEA,4DAA4D;EAC5D;GACC,aAAa;GACb,oBAAoB;GACpB,6BAA6B;EAC9B;;;EAGA,2BAA2B;EAC3B;CACD;GACE,oEAAoE;GACpE,WAAW;CACb;;CAEA;;GAEE,aAAa,EAAE,+BAA+B;CAChD;;EAEC;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;EACA,eAAe;EACf,uBAAuB;EACvB;GACC;IACC,eAAe;GAChB;;CAEF;GACE,iBAAiB,EAAE,6CAA6C;GAChE,wBAAwB;GACxB,aAAa;CACf;;CAEA;EACC,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;CACb;CACA;EACC,SAAS;EACT,WAAW;CACZ;;EAEC","sourcesContent":["/* src/components/Layout.css */\n\n.app-layout {\n\tdisplay: flex;\n  }\n  \n  /* Main content area that takes remaining space */\n  .main-content {\n\tmargin-left: 250px; /* Same as sidebar width */\n\tpadding: 25px;\n\twidth: calc(100% - 250px); /* Full width minus sidebar */\n\tmin-height: 100vh;\n\tbackground-color: #f8f9fa; /* Light background for content area */\n\tposition: relative; /* Needed for absolute positioning of children like button/panel */\n\tbox-sizing: border-box;\n  }\n  \n  .page-content {\n\t  /* Add specific styles for the area where route components render if needed */\n\t  background-color: #ffffff; /* White background for page content */\n\t  padding: 20px;\n\t  border-radius: 8px;\n\t  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n  }\n  \n  \n  .settings-toggle-button {\n\t  position: absolute;\n\t  top: 20px;\n\t  right: 25px;\n\t  z-index: 1001; /* Above settings panel overlay */\n\t  background-color: #6c757d;\n\t  color: white;\n\t  border: none;\n\t  border-radius: 50%;\n\t  width: 50px;\n\t  height: 50px;\n\t  display: flex;\n\t  align-items: center;\n\t  justify-content: center;\n\t  cursor: pointer;\n\t  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n\t  transition: background-color 0.2s ease;\n  }\n  \n  .settings-toggle-button:hover {\n\t  background-color: #5a6268;\n  }\n  \n  /* Style for the settings panel when it's overlaid */\n  /* We apply this class directly in Layout.js */\n  .settings-panel-overlay {\n\t  position: absolute;\n\t  top: 80px; /* Below the toggle button */\n\t  right: 25px;\n\t  z-index: 1000; /* Below toggle, above content */\n\t  width: 320px;\n\t  max-width: 90%; /* Ensure it fits on smaller screens */\n\t  background-color: white;\n\t  border-radius: 8px;\n\t  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n\t  border: 1px solid #dee2e6;\n  }\n  \n  /* Adjust SettingsPanel internal styles slightly if needed */\n  .settings-panel-overlay h4 {\n\t  margin-top: 0;\n\t  padding-bottom: 10px;\n\t  border-bottom: 1px solid #eee;\n  }\n  \n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n\t.main-menu {\n\t  /* Example: Make sidebar smaller or collapsible on smaller screens */\n\t  width: 60px;\n\t}\n  \n\t.main-menu .menu-title,\n\t.main-menu .menu-text {\n\t  display: none; /* Hide text, show only icons */\n\t}\n  \n\t .main-menu .menu-link {\n\t   justify-content: center;\n\t   padding: 15px 0;\n\t }\n\t .main-menu .menu-icon {\n\t   margin-right: 0;\n\t }\n\t .main-menu .menu-header {\n\t\tpadding: 15px 0;\n\t\tjustify-content: center;\n\t }\n\t  .main-menu .menu-logo-icon {\n\t\t  margin-right: 0;\n\t  }\n  \n\t.main-content {\n\t  margin-left: 60px; /* Adjust margin to match collapsed sidebar */\n\t  width: calc(100% - 60px);\n\t  padding: 15px;\n\t}\n  \n\t.settings-toggle-button {\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\twidth: 45px;\n\t\theight: 45px;\n\t}\n\t.settings-panel-overlay {\n\t\ttop: 70px;\n\t\tright: 15px;\n\t}\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
